import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
body {
    font-family: Muli;
    background-color: #f1f1f1;
    color: #393939;
}`;
